export default {"src":"/_next/static/media/modx.886cba0a.svg","height":66,"width":303,"blurWidth":0,"blurHeight":0};